Vue.component('v-menu', {
  mounted: function () {
    var vm = this
    var links = $(this.$el).find('.menu-sm__title')
    links.on('click', function () {
      if (vm.$store.viewport === 'mobile') {
        $(this).siblings('.menu-sm__links').slideToggle().css({display: 'flex'})
        $(this).find('.menu-sm__arrow').toggleClass('menu-sm__arrow--opened')
      }
    })
  }
})
